import 'fomantic-ui-less/semantic.less';
import 'datatables.net-se/css/dataTables.semanticui.css';

module.exports = {};
